module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "photoCell",
    staticClass: "photo-cell col-6 col-md-3 col-lg-2",
    style: ({
      height: _vm.photoCellHeight + 'px'
    })
  }, [_c('div', {
    staticClass: "photo-cell-inner h-100 p-1",
    class: {
      favorite: _vm.isFavorited
    }
  }, [_c('div', {
    staticClass: "row no-gutters h-100"
  }, [_c('div', {
    staticClass: "col text-center h-100"
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.smallThumbnailUrl),
      expression: "smallThumbnailUrl",
      arg: "background-image"
    }],
    staticClass: "photo-image point-cursor contain",
    staticStyle: {
      "background-position": "bottom"
    },
    on: {
      "click": _vm.showPhotoImageModal
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-auto text-center h-100"
  }, [_c('div', {
    staticClass: "d-flex flex-column h-100"
  }, [_c('div', {
    staticClass: "photo-no text-center mb-auto"
  }, [_vm._v(_vm._s(_vm.photo.photo_no))]), _vm._v(" "), _c('div', {}, [_c('i', {
    staticClass: "fa fa-search-plus image-zoom-btn",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.showPhotoImageModal
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [(!_vm.isFavorited) ? _c('button', {
    staticClass: "favorite-operation btn btn-default px-1",
    attrs: {
      "data-toggle": "modal"
    },
    on: {
      "click": _vm.addCart
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui['6'][10]"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-heart",
    attrs: {
      "aria-hidden": "true"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isFavorited) ? _c('button', {
    staticClass: "favorite-operation btn btn-danger px-1",
    attrs: {
      "data-toggle": "modal"
    },
    on: {
      "click": _vm.removeCart
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui['6'][9]"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-heart",
    attrs: {
      "aria-hidden": "true"
    }
  })], 1) : _vm._e()])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4d12da91!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/partials/Order/Catalog/SnapVerticalPhoto.vue
// module id = 700
// module chunks = 0